import styled from "styled-components";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";

type TextType = {
    color: string;
}

type BorderType = {
    borderColor: string;
    background: string;
    highlight?: boolean;
}

type StatusType = {
    background: string;
    color: string;
}

type ButtonType = {
    color: string;
    background: string;
    accent: string;
    size: number;
};

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const Card = styled.div<BorderType>`
  flex: 1 1 calc(50% - 32px);
  min-width: 280px;
  margin: 16px;
  display: flex;
  flex-direction: column;
  border: ${props => props.highlight ? `1.5px solid ${props.borderColor}` : `1px solid ${props.borderColor}`};
  border-radius: 8px;
  padding: 16px;
  background-color: ${props => props.background};
`;

type AlertBannerType = {
    background: string;
    color: string;
}

export const AlertBanner = styled.div<AlertBannerType>`
  display: flex;
  align-items: center;
  gap: 8px;
  background: ${props => props.background};
  color: ${props => props.color};
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
`;

type IconWrapperType = {
    background: string;
    color: string;
}

export const CardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
  flex: 1;
  min-width: 0;
`;

export const IconWrapper = styled.div<IconWrapperType>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  min-width: 32px;
  height: 32px;
  border-radius: 6px;
  background: ${props => props.background};
`;

export const ProductTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const ProductSubtitle = styled.span<TextType>`
  font-size: 11px;
  color: ${props => props.color};
`;

export const Divider = styled.div<TextType>`
  height: 1px;
  background-color: ${props => props.color};
  margin: 0 0 12px;
`;

export const ProductName = styled.span<TextType>`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.color};
`;

export const ContentValue = styled.div<TextType>`
  font-size: 28px;
  font-weight: bold;
  color: ${props => props.color};
  margin-bottom: 4px;
`;

export const PeriodText = styled.div<TextType>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${props => props.color};
  margin-bottom: 6px;
`;

export const ExpireDateText = styled.div<TextType>`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: ${props => props.color};
  margin-bottom: 12px;
`;

export const ContentStatus = styled.div<StatusType>`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.background};
  color: ${props => props.color};
  padding: 0px 6px;
  border-radius: 5px;
  height: 16px;
  font-weight: bold;
  letter-spacing: .5px;
  font-size: 10px;
`;

export const Button = styled.button<ButtonType>`
  display: flex;
  flex-direction: column;
  padding: 6px;
  align-items: flex-start;
  justify-content: space-between;
  text-align: left;
  background-color: ${props => props.background};
  color: ${props => props.color};
  font-size: ${props => `${props.size}px`};
  font-weight: bold;
  width: 110px;
  min-width: 110px;
  height: 80px;
  min-height: 80px;
  border-radius: 5px;
  border: 1px solid ${props => props.accent};

  &:hover {
    border-color: transparent;
    box-shadow: 0 0 0 2px ${props => hexToRGBA(props.accent, .58)};
    outline: none;
    transition: box-shadow .3s ease-out .1s, border .3s ease-out, border-radius .3s ease-out, background-color .2s ease-out, color .2s ease-out, transform .2s ease-out;
  }
`;

export const MessagePanel = styled.div<TextType>`
  font-size: 13px;
  color: ${props => props.color};
  line-height: 1.5;
  margin-bottom: 4px;
`;

export const ContainerButtons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  padding-top: 8px;
`;
